export enum BroadcastDeviceVodType {
  tv = 'tv',
  clinic_vod = 'clinic_vod',
  health_vod = 'health_vod',
}
